// Sheria portal interactions — loaded via `web_include_js` in hooks.py.
// Replaces the inline <script> blocks previously embedded in www/ templates.

frappe.ready(function () {
	setupServiceFilter();
	setupServiceRequestForm();
});

function setupServiceFilter() {
	const filters = document.querySelectorAll(".sheria-filter");
	if (!filters.length) return;

	filters.forEach((btn) => {
		btn.addEventListener("click", function () {
			const category = this.dataset.category;
			filters.forEach((b) => b.classList.toggle("active", b === this));
			document.querySelectorAll(".service-card").forEach((card) => {
				const show = category === "all" || card.dataset.category === category;
				card.classList.toggle("d-none", !show);
			});
		});
	});
}

function setupServiceRequestForm() {
	const form = document.getElementById("service-request-form");
	if (!form) return;

	const val = (id) => document.getElementById(id).value;

	form.addEventListener("submit", function (e) {
		e.preventDefault();
		frappe.call({
			method: "sheria.api.submit_service_request",
			args: {
				service_type: val("service_type"),
				description: val("description"),
				client_name: val("client_name"),
				priority: val("priority"),
				email: val("email"),
				phone: val("phone"),
			},
			callback: function (r) {
				if (r.message && r.message.status === "success") {
					form.classList.add("d-none");
					document.getElementById("success-message").classList.remove("d-none");
				}
			},
			error: function () {
				frappe.msgprint(__("There was an error submitting your request. Please try again."));
			},
		});
	});
}
